import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import useMedia from "use-media";
import messageConst from "../../../const/messageConst";
import arrow_bottom from "../../../resources/icons/ico_arrow_bottom.svg";
import arrow_top from "../../../resources/icons/ico_arrow_top.svg";
import { BlackCheckBox } from "../../atoms/blackCheckBox";
import { Label } from "../../atoms/label";
import { ModalCheckboxList } from "../../molecules/modalCheckboxList";

const CheckListPopupContainer = (props) => {
    const { state,
        planConditions,
        grade,
        roomDetailCriteria,
        food,
        privilegedService,
        membershipFacility,
        setGrade,
        setRoomDetailCriteria,
        setPlanConditions,
        setPrivilegedService,
        setFood,
        setMembershipFacility,
        setDispFacility,
        setDispDetailCondition,
        onClickOpenCheckListWindow,
    } = props;
    const store = useStore();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupFlg = state.checkListPopup;
    const [dataList, setDataList] = useState([]);

    // Popup表示時のstore値を初期値として持っておく(×ボタンが押されたときに元に戻す用)
    const [initialMembershipFacility, setInitialMembershipFacility] = useState(undefined);
    const [initialPlanConditions, setInitialPlanConditions] = useState(undefined);
    const [initialGrade, setInitialGrade] = useState(undefined);
    const [initialRoomDetailCriteria, setInitialRoomDetailCriteria] = useState(undefined);
    const [initialFood, setInitialFood] = useState(undefined);
    const [initialPrivilegedService, setInitialPrivilegedService] = useState(undefined);

    const popupRef = useRef(null);
    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    }, [popupFlg]);

    useEffect(() => {
        if (state.facilityFlg) {
            setDataList(store.getState().facility);
        } else if (state.detailCriteriaFlg) {
            setDataList(store.getState().detailCondition);
        }
    }, [state.facilityFlg, state.detailCriteriaFlg]);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const copy = (obj) => {
      return JSON.parse(JSON.stringify(obj));
    }
    useEffect(() => {
        if (popupFlg) {
            document.getElementById("checkListDecision").disabled = false;
            // 初期値の保存
            setInitialMembershipFacility(copy(membershipFacility));
            setInitialPlanConditions(copy(planConditions));
            setInitialGrade(copy(grade));
            setInitialRoomDetailCriteria(copy(roomDetailCriteria));
            setInitialFood(copy(food));
            setInitialPrivilegedService(copy(privilegedService));
        }
    }, [popupFlg]);

    // グループ内施設を全選択
    const onChangeFacilityGroup = (name, groupIndex) => {
        let newGroupList = [];
        if (name === "membership") {
            let target = membershipFacility.membership[groupIndex]["checked"];
            membershipFacility.membership[groupIndex]["checked"] = !target;
            membershipFacility.membership.forEach(group => {
                membershipFacility.membership[groupIndex].shisetsuList.forEach((item, itemIndex) => {
                    if (!membershipFacility.membership[groupIndex]["shisetsuList"][itemIndex]["disabled"]) {
                        if (target) {
                            membershipFacility.membership[groupIndex]["shisetsuList"][itemIndex]["checked"] = false;
                        } else {
                            membershipFacility.membership[groupIndex]["shisetsuList"][itemIndex]["checked"] = true;
                        }
                    }
                })
                newGroupList.push(group);
            })
            setMembershipFacility({ membership: newGroupList, ippan: membershipFacility.ippan });
        } else {
            let target = membershipFacility.ippan[groupIndex]["checked"];
            membershipFacility.ippan[groupIndex]["checked"] = !target;
            membershipFacility.ippan.forEach(group => {
                membershipFacility.ippan[groupIndex].shisetsuList.forEach((item, itemIndex) => {
                    if (!membershipFacility.ippan[groupIndex]["shisetsuList"][itemIndex]["disabled"]) {
                        if (target) {
                            membershipFacility.ippan[groupIndex]["shisetsuList"][itemIndex]["checked"] = false;
                        } else {
                            membershipFacility.ippan[groupIndex]["shisetsuList"][itemIndex]["checked"] = true;
                        }
                    }
                })
                newGroupList.push(group);
            })
            setMembershipFacility({ membership: membershipFacility.membership, ippan: newGroupList });
        }

    }

    // チェック状態変更
    const onChangeDetailConditionChecked = (name, groupIndex, index) => {
        let newList = [];
        let target = false;
        switch (name) {
            case "membership":
                target = membershipFacility.membership[groupIndex]["shisetsuList"][index]["checked"];
                membershipFacility.membership[groupIndex]["shisetsuList"][index]["checked"] = !target;
                if (target) {
                    membershipFacility.membership[groupIndex]["checked"] = false;
                } else {
                    let isAllChecked = !membershipFacility.membership[groupIndex]["shisetsuList"].some(value => value.disabled === false && value.checked === false);
                    if (isAllChecked) {
                        membershipFacility.membership[groupIndex]["checked"] = true;
                    }
                }
                membershipFacility.membership.forEach(value => {
                    newList.push(value);
                })
                setMembershipFacility({ membership: newList, ippan: membershipFacility.ippan });
                break;
            case "ippan":
                target = membershipFacility.ippan[groupIndex]["shisetsuList"][index]["checked"];
                membershipFacility.ippan[groupIndex]["shisetsuList"][index]["checked"] = !target;
                if (target) {
                    membershipFacility.ippan[groupIndex]["checked"] = false;
                } else {
                    let isAllChecked = !membershipFacility.ippan[groupIndex]["shisetsuList"].some(value => value.disabled === false && value.checked === false);
                    if (isAllChecked) {
                        membershipFacility.ippan[groupIndex]["checked"] = true;
                    }
                }
                membershipFacility.ippan.forEach(value => {
                    newList.push(value);
                })
                setMembershipFacility({ membership: membershipFacility.membership, ippan: newList });
                break;
            case "planConditions":
                target = planConditions[index]["checked"];
                planConditions[index]["checked"] = !target;
                planConditions.forEach(value => {
                    newList.push(value);
                })
                setPlanConditions(newList);
                break;
            case "grade":
                target = grade[index]["checked"];
                grade[index]["checked"] = !target;
                grade.forEach(value => {
                    newList.push(value);
                })
                setGrade(newList);
                break;
            case "roomDetailCriteria":
                target = roomDetailCriteria[index]["checked"];
                roomDetailCriteria[index]["checked"] = !target;
                roomDetailCriteria.forEach(value => {
                    newList.push(value);
                })
                setRoomDetailCriteria(newList);
                break;
            case "food":
                target = food[index]["checked"];
                food[index]["checked"] = !target;
                food.forEach(value => {
                    newList.push(value);
                })
                setFood(newList);
                break;
            case "privilegedService":
                target = privilegedService[index]["checked"];
                privilegedService[index]["checked"] = !target;
                privilegedService.forEach(value => {
                    newList.push(value);
                })
                setPrivilegedService(newList);
                break;
            default:
                break;
        }
    }

    // グループ内施設全表示
    const onClickArrow = (name, index) => {
        let newGroupList = [];
        if (name === "membership") {
            membershipFacility.membership[index]["displayFlg"] = !membershipFacility.membership[index]["displayFlg"];
            membershipFacility.membership.forEach(group => {
                newGroupList.push(group);
            })
            setMembershipFacility({ membership: newGroupList, ippan: membershipFacility.ippan });
        } else {
            membershipFacility.ippan[index]["displayFlg"] = !membershipFacility.ippan[index]["displayFlg"];
            membershipFacility.ippan.forEach(group => {
                newGroupList.push(group);
            })
            setMembershipFacility({ membership: membershipFacility.membership, ippan: newGroupList });
        }
    }

    const getCheckboxList = () => {
        const membershipCheckboxList = [];
        if (membershipFacility.membership) {
            membershipFacility.membership.forEach((value, index) => {
                membershipCheckboxList.push(<div key={value.title}>
                    {<div key={value.listName + index}>
                        <div style={{ display: "flex" }}>
                            <BlackCheckBox
                                checkAreaStyle={isMobilePhone ? styles.divItemTitleStyleSp : styles.divItemTitleStyle}
                                id={value.mainGroupCd}
                                name={value.mainGroupCd}
                                // item={value.mainGroupName}
                                value={value.mainGroupCd}
                                checked={value.checked}
                                disabled={value.shisetsuList.findIndex(value => !value.disabled) === -1}
                                onChange={() => onChangeFacilityGroup("membership", index)} />
                            <div onClick={() => onClickArrow("membership", index)} style={{ display: "flex", alignItems: "center", marginTop: "10px", marginRight: "10px" }}>
                                <Label
                                    label={value.mainGroupName}
                                    style={{ hight: "auto", marginRight: "10px" }}
                                />
                                <img src={value.displayFlg ? arrow_top : arrow_bottom} alt="" className="arrowImg" />
                            </div>
                        </div>
                        <Label className={value.shisetsuList.findIndex(value => !value.disabled) === -1 ? "membership_disabledHonkanLabel" : "hiddenItem"} label={messageConst.REQUIRE_KAIINKEN_MESSAGE} />
                    </div>}
                    <ModalCheckboxList
                        divStyle={value.displayFlg ? isMobilePhone ? styles.divStyleSp : styles.divStyle : styles.none}
                        checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                        data={value.shisetsuList?.filter(shisetsuInfo => shisetsuInfo.openFlg)}
                        title={value.mainGroupCd}
                        name="membership"
                        groupIndex={index}
                        onChange={onChangeDetailConditionChecked}
                        labelClassName={"shortening"}
                        afterLabel={value.shisetsuList.findIndex(value => !value.disabled) === -1 ? "" : messageConst.REQUIRE_KAIINKEN_MESSAGE}
                        afterLabelClassName="membership_disabledLabel"
                    /></div>);
            });
        }
        const ippanCheckboxList = [];
        if (membershipFacility.ippan) {
            membershipFacility.ippan.forEach((value, index) => {
                ippanCheckboxList.push(<div key={value.title}>
                    {<div key={value.listName + index}>
                        <div style={{ display: "flex" }}>
                            <BlackCheckBox
                                checkAreaStyle={isMobilePhone ? styles.divItemTitleStyleSp : styles.divItemTitleStyle}
                                id={value.mainGroupCd}
                                name={value.mainGroupCd}
                                // item={value.mainGroupName}
                                value={value.mainGroupCd}
                                checked={value.checked}
                                onChange={() => onChangeFacilityGroup("ippan", index)} />
                            <div onClick={() => onClickArrow("ippan", index)} style={{ display: "flex", alignItems: "center", marginTop: "10px", marginRight: "10px" }}>
                                <Label
                                    label={value.mainGroupName}
                                    style={{ hight: "auto", marginRight: "10px" }}
                                />
                                <img src={value.displayFlg ? arrow_top : arrow_bottom} alt="" className="arrowImg" />
                            </div>
                        </div></div>}
                    <ModalCheckboxList
                        divStyle={value.displayFlg ? isMobilePhone ? styles.divStyleSp : styles.divStyle : styles.none}
                        checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                        data={value.shisetsuList}
                        title={value.mainGroupCd}
                        name="ippan"
                        groupIndex={index}
                        onChange={onChangeDetailConditionChecked}
                        labelClassName={"shortening"}
                        afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                        afterLabelClassName="membership_disabledLabel"
                    /></div >);
            });
        }
        return (<>
                <Label className="popupTitle" label="会員制ホテル" />{membershipCheckboxList}
                {ippanCheckboxList.length > 0 
                ? <><Label className="popupTitle" label="一般ホテル" />{ippanCheckboxList}</>
                : null
                }
            </>);
    };
    const facilityCheckboxes = getCheckboxList();

    // 選択した値をstoreに保存
    const onClickDecision = () => {
        // 二度押し防止
        document.getElementById("checkListDecision").disabled = true;

        let dispText = "";
        let paramId = "";
        if (state.facilityFlg) {
            membershipFacility.membership.forEach(group => {
                group.shisetsuList.forEach(item => {
                    if (item.checked) {
                        dispText = dispText + (dispText == "" ? "" : ", ");
                        dispText = dispText + item.value;
                        paramId = paramId + (paramId == "" ? "" : ", ");
                        paramId = paramId + item.id;
                    }
                })
            })
            membershipFacility.ippan.forEach(group => {
                group.shisetsuList.forEach(item => {
                    if (item.checked) {
                        dispText = dispText + (dispText == "" ? "" : ", ");
                        dispText = dispText + item.value;
                        paramId = paramId + (paramId == "" ? "" : ", ");
                        paramId = paramId + item.id;
                    }
                })
            })
            setDispFacility(dispText);
        } else if (state.detailCriteriaFlg) {
            planConditions.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                    paramId = paramId + (paramId == "" ? "" : ", ");
                    paramId = paramId + item.id;
                }
            })
            // grade.forEach(item => {
            //     if (item.checked) {
            //         dispText = dispText + (dispText == "" ? "" : ", ");
            //         dispText = dispText + item.value;
            //         paramId = paramId + (paramId == "" ? "" : ", ");
            //         paramId = paramId + item.id;
            //     }
            // })
            food.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                    paramId = paramId + (paramId == "" ? "" : ", ");
                    paramId = paramId + item.id;
                }
            })
            privilegedService.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                    paramId = paramId + (paramId == "" ? "" : ", ");
                    paramId = paramId + item.id;
                }
            })
            setDispDetailCondition(dispText);
        }
        onClickOpenCheckListWindow();
    };

    const clear = () => {
      // 初期値で上書きする
      setMembershipFacility(initialMembershipFacility);
      setPlanConditions(initialPlanConditions);
      setGrade(initialGrade);
      setRoomDetailCriteria(initialRoomDetailCriteria);
      setFood(initialFood);
      setPrivilegedService(initialPrivilegedService);

      onClickOpenCheckListWindow();
    }

    return (
        <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
            <div className="popupInner" ref={popupRef}>
                <div className="popupHeader">
                    <div className="closeBtn" id="js-close-btn" onClick={clear}>
                    </div>
                    <h4 className="popupInnerText" >{state.popupTitle}</h4>
                </div>
                {state.facilityFlg ? facilityCheckboxes : (state.detailCriteriaFlg || state.roomDetailCriteriaFlg) ?
                    <div>
                        <div className={state.detailCriteriaFlg && !state.gradeFlg ? "" : "hiddenItem"}>
                            <Label className="popupTitle" label="プラン条件" />
                            <ModalCheckboxList
                                divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                                checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                                data={planConditions}
                                title="プラン条件"
                                name="planConditions"
                                groupIndex={0}
                                onChange={onChangeDetailConditionChecked}
                                labelClassName={"shortening"}
                                afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                                afterLabelClassName="membership_disabledLabel"
                            />
                        </div>
                        <div className={!state.gradeFlg ? "hiddenItem" : ""}>
                            <Label className="popupTitle" label="部屋条件" />
                            <ModalCheckboxList
                                divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                                checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                                data={grade}
                                title="部屋条件"
                                name="grade"
                                groupIndex={0}
                                onChange={onChangeDetailConditionChecked}
                                labelClassName={"shortening"}
                                afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                                afterLabelClassName="membership_disabledLabel"
                            />
                        </div>
                        <div className={!state.roomDetailCriteriaFlg ? "hiddenItem" : ""}>
                            <Label className="popupTitle" label="部屋条件" />
                            <ModalCheckboxList
                                divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                                checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                                data={roomDetailCriteria}
                                title="部屋条件"
                                name="roomDetailCriteria"
                                groupIndex={0}
                                onChange={onChangeDetailConditionChecked}
                                labelClassName={"shortening"}
                                afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                                afterLabelClassName="membership_disabledLabel"
                            />
                        </div>
                        <div className={state.detailCriteriaFlg && !state.gradeFlg ? "" : "hiddenItem"}>
                            <Label className="popupTitle" label="料理(夕食)" />
                            <ModalCheckboxList
                                divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                                checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                                data={food}
                                title="料理"
                                name="food"
                                groupIndex={0}
                                onChange={onChangeDetailConditionChecked}
                                labelClassName={"shortening"}
                                afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                                afterLabelClassName="membership_disabledLabel"
                            />
                        </div>
                        <div className={state.detailCriteriaFlg && !state.gradeFlg ? "" : "hiddenItem"}>
                            <Label className="popupTitle" label="占有日（権利泊数）や宿泊券を使用しないサービス" />
                            <ModalCheckboxList
                                divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                                checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                                data={privilegedService}
                                title="占有日（権利泊数）や宿泊券を使用しないサービス"
                                name="privilegedService"
                                groupIndex={0}
                                onChange={onChangeDetailConditionChecked}
                                labelClassName={"shortening"}
                                afterLabel={messageConst.REQUIRE_KAIINKEN_MESSAGE}
                                afterLabelClassName="membership_disabledLabel"
                            />
                            <Label className="privilegedServiceText" label="" />
                        </div>
                    </div>
                    : null}
                <div className="buttonArea  buttonAreaSticky" >
                    <button id="checkListDecision" className="button" onClick={onClickDecision}>決 定</button>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        planConditions: state.planConditions,
        grade: state.grade,
        roomDetailCriteria: state.roomDetailCriteria,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setRoomDetailCriteria: (item) => {
            dispatch({ type: "ROOM_DETAIL_CRITERIA", payload: { roomDetailCriteria: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckListPopupContainer);

export const styles = {
    divStyle: {
        // display: "flex",
        width: "80%",
        textAlign: "left",
        alignContent: "center",
        margin: "0px 5% 20px 10%",
        fontSize: "small",
        // flexWrap: "wrap",
    },
    divStyleSp: {
        // display: "flex",
        // flexWrap: "wrap",
        textAlign: "left",
        alignContent: "center",
        padding: "20px 10%",
        fontSize: "small",
        justifyContent: "space-between",
    },
    divItemStyle: {
        // display: "flex",
        // flexWrap: "wrap",
        // width: "33%",
        textAlign: "left",
        alignContent: "center",
        fontSize: "small",
        margin: "15px 0px 0px 0px",
    },
    divItemStyleSp: {
        // width: "48%",
        textAlign: "left",
        margin: "20px 0px 0px 0px",
    },
    divItemTitleStyle: {
        padding: "10px 0% 10px 5%",
        color: "#696969",
        justifyContent: "left",
        fontWeight: "bold",
    },
    divItemTitleStyleSp: {
        textAlign: "left",
        padding: "10px 0% 10px 5%",
        color: "#696969",
        fontWeight: "bold",
    },
    none: {
        display: "none"
    }
}